import { gql, useQuery } from '@apollo/client';
import {
  TRANSLATED_STRING_FIELDS,
  translateBackend,
} from '@assets/i18n/config';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const FETCH_ACCOUNT_NAME = gql`
  query fetchAccount($id: SafeString!) {
    fetchAccount(input: { accountId: $id }) {
      account { type translatedNickName { ${TRANSLATED_STRING_FIELDS} } }
    }
  }
`;

export function AccountBreadcrumb() {
  const { t } = useTranslation();
  const { data } = useQuery(FETCH_ACCOUNT_NAME, {
    variables: { id: useParams().accountId },
  });

  return data
    ? translateBackend(data.fetchAccount.account.translatedNickName) ||
        t(`accountTypes:${data.fetchAccount.account.type}`)
    : t('client:account');
}
